import React from "react";
import styles from "./first.module.scss";
import Button, { BTN_VARIANTS } from "../../components/Button";
import { useNavigate } from "react-router-dom";

const First = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <div className={styles["scrolling-words-container"]}>
          <div className={styles["scrolling-words-box"]}>
            <ul>
              <li>Launch a dVPN Using</li>
              <li>Use dVPN App based on</li>
              <li>Run a dVPN Node For</li>
              <li>Launch a dVPN Using</li>
            </ul>
          </div>
          <span>Sentinel</span>
        </div>
        <div className={styles["scrolling-words-container-mobile"]}>
          <span className={styles["left-text"]}>Launch a dVPN Using</span>
          <span className={styles["right-text"]}>Sentinel</span>
        </div>
      </div>
      <section className={styles.subtitle}>
        <span>Fast and Cheap, Open source, Censorship Resistant.</span>
      </section>
      <section className={styles.description}>
        <span>
          Browse your favorite websites safely from anywhere in the world by
          using the Sentinel dVPN app or any of the other dVPN apps built using
          Sentinel
        </span>
      </section>
      <section className={styles.btns}>
        <Button
          onClick={() => navigate("/dapps")}
          variant={BTN_VARIANTS.primary}
          className={styles.btn}
        >
          <span>Download Sentinel dVPN</span>
        </Button>
        <Button
          onClick={() => window.open("https://stats.sentinel.co/")}
          variant={BTN_VARIANTS.secondary}
          className={styles.btn}
        >
          <span>Explore The Network</span>
        </Button>
      </section>
    </div>
  );
};

export default First;
